module.exports = "/virtual-football-league/img/amblems/right/logos/ESPANYOL.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/ESPANYOL.png
// module id = 2171
// module chunks = 4